import { textTypes } from '@/components/common/inputs/constants'
import * as ruleNames from '@/components/common/inputs/constants/ruleNames'

export const getErrorMessage = (
  name: string,
  params: { [key: string]: any }
): string => {
  switch (name) {
    case ruleNames.REQUIRED:
      return '必須の項目です。'

    case ruleNames.MIN_LENGTH:
      return `${params.min}文字以上で入力してください。`

    case ruleNames.MAX_LENGTH:
      return `${params.max}文字以下で入力してください。`

    case ruleNames.BETWEEN_LENGTH:
      return `${params.min}文字以上、${params.max}文字以下で入力してください。`

    case ruleNames.MIN_VALUE:
      return `${params.min}以上の値を入力してください。`

    case ruleNames.MAX_VALUE:
      return `${params.max}以下の値を入力してください。`

    case ruleNames.BETWEEN:
      return `${params.min}以上、${params.max}以下の値を入力してください。`

    case ruleNames.ALPHA_NUM:
    case ruleNames.INTEGER:
    case ruleNames.URL:
    case ruleNames.HIRAGANA:
      return `${textTypes[name]}以外の文字は使用できません。`

    case ruleNames.EMAIL:
      return `${textTypes[name]}以外は使用できません。`

    case ruleNames.END_GREATER_THAN_START:
      return '終了時刻には、開始日時よりも後の時刻を指定してください。'

    default:
      return '入力に誤りがあります。'
  }
}
